import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export const useAdminNotifications = () => {
  return useQuery({
    queryKey: ['adminNotifications'],
    queryFn: async () => {
      // Count unclaimed messages: conversations where supplier_page is unclaimed AND admin_connected = false
      const { count: unclaimedCount, error: unclaimedError } = await supabase
        .from('conversations')
        .select(`
          id,
          supplier_requests!inner(
            supplier_page_id,
            supplier_pages!inner(
              claimed
            )
          )
        `, { count: 'exact', head: true })
        .eq('admin_connected', false)
        .eq('supplier_requests.supplier_pages.claimed', false);

      if (unclaimedError) {
        console.error('Error fetching unclaimed messages count:', unclaimedError);
      }

      // Count matching requests: customer_requests where direct_request is false or null
      const { count: matchingCount, error: matchingError } = await supabase
        .from('customer_requests')
        .select('*', { count: 'exact', head: true })
        .or('direct_request.is.null,direct_request.eq.false');

      if (matchingError) {
        console.error('Error fetching matching requests count:', matchingError);
      }

      // Count new embed requests: supplier_pages with embed_enabled=true, enabled within last 7 days
      const sevenDaysAgo = new Date(Date.now() - 7 * 24 * 60 * 60 * 1000).toISOString();
      const { count: embedCount, error: embedError } = await supabase
        .from('supplier_pages')
        .select('*', { count: 'exact', head: true })
        .eq('embed_enabled', true)
        .gte('embed_enabled_at', sevenDaysAgo);

      if (embedError) {
        console.error('Error fetching embed requests count:', embedError);
      }

      // Count pending supplier registrations: supplier_profile where Activated = false
      const { count: pendingCount, error: pendingError } = await supabase
        .from('supplier_profile')
        .select('id', { count: 'exact', head: true })
        .eq('Activated', false);

      if (pendingError) {
        console.error('Error fetching pending registrations count:', pendingError);
      }

      const unclaimed = unclaimedCount ?? 0;
      const matching = matchingCount ?? 0;
      const embeds = embedCount ?? 0;
      const pendingRegistrationsCount = pendingCount ?? 0;

      return {
        unclaimedCount: unclaimed,
        matchingCount: matching,
        embedCount: embeds,
        pendingRegistrationsCount,
        totalCount: unclaimed + matching + embeds + pendingRegistrationsCount,
      };
    },
    refetchInterval: 30000, // Refresh every 30 seconds
    staleTime: 10000, // Consider data stale after 10 seconds
  });
};
